import EventSchedule16 from '@carbon/icons-react/es/event--schedule/16';
import Help16 from '@carbon/icons-react/es/help/16';
import { Row, Col, Tooltip } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  gap: var(--spacing-02);
`;

export const Title = () => {
  return (
    <Row>
      <Col flex={1}>
        <Wrapper>
          <EventSchedule16 />
          <strong>
            <FormattedMessage id="project.overview.intervals.title" />
          </strong>
          <Tooltip
            title={<FormattedMessage id="settings.events.tooltip" />}
            placement="rightTop"
          >
            <Help16 />
          </Tooltip>
        </Wrapper>
      </Col>
    </Row>
  );
};
